export type StakeholderStatusBadge = {
  label: string;
  color: 'success' | 'warning' | 'error' | 'primary' | 'info';
  variant: 'filled' | 'outlined';
};


export const getStakeholderStatusBadges = (stakeholder: any): StakeholderStatusBadge[] => {
  if (!stakeholder) {
    return [];
  }

  const badges: StakeholderStatusBadge[] = [];

  if (stakeholder.isInternational) {
    badges.push({ label: 'International', color: 'info', variant: 'outlined' });
  }

  if (stakeholder.bankingDetailsVerified) {
    badges.push({ label: 'Banking Details Verified', color: 'success', variant: 'outlined' });
  }

  if (!stakeholder.isInternational && stakeholder.taxClearanceExpiryDate) {
    const isExpired = new Date(stakeholder.taxClearanceExpiryDate) < new Date();
    badges.push({
      label: `Tax Clearance Expires: ${new Date(stakeholder.taxClearanceExpiryDate).toLocaleDateString()}`,
      color: isExpired ? 'error' : 'primary',
      variant: 'outlined',
    });
  }

  if (!stakeholder.isInternational) {
    badges.push(
      stakeholder.isTaxClearanceValid
        ? { label: 'Tax Clearance Valid', color: 'success', variant: 'outlined' }
        : { label: 'No Valid Tax Clearance', color: 'error', variant: 'filled' }
    );
  }

  badges.push(
    stakeholder.isStakeholderVerified
      ? { label: 'Verified', color: 'success', variant: 'filled' }
      : { label: 'Not Verified', color: 'warning', variant: 'outlined' }
  );

  if (stakeholder.suspended) {
    badges.push({ label: 'Suspended', color: 'error', variant: 'filled' });
  }

  return badges;
};
